module.exports = __webpack_public_path__ + "static/img/l_1_1.395221a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/My/l_1_1.png
// module id = nEKZ
// module chunks = 0 1 2 3 4 5 6